import React, { useState, useEffect } from 'react';
import moment from 'moment';
import 'moment-timezone';
import CommonUtils from '../../util/CommonUtils';
import SessionManager from '../../routes/SessionManager';
import API from '../../service/SiteKickAPIService';
import { useSearchParams } from 'react-router-dom';
import BreadCrumb from '../../components/bootstrap4/BreadCrumb';
import { Table, Button, DatePicker, Modal } from 'antd';
import SecurityIncidentReport from './security_incident_report';
import ZoneHistoryCarousel from '../../components/zone-history/ZoneHistoryCarousel';
import $ from 'jquery';

const WhircIncidentManager = () => {

    const [dateRange, setDateRange] = useState([
        moment().subtract(1, 'days').hour(16).minute(0).second(0),
        moment().hour(6).minute(0).second(0)
    ]); //
    const [searchParams] = useSearchParams();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [summaryData, setSummaryData] = useState([]);
    const [expandedRowDetails, setExpandedRowDetails] = useState({});
    const [loadingDetails, setLoadingDetails] = useState({});
    const [reportModalVisible, setReportModalVisible] = useState(false);
    const [selectedSiteForReport, setSelectedSiteForReport] = useState(null);
    const [sendReportHandler, setSendReportHandler] = useState(null);
    const [loadingVideo, setLoadingVideo] = useState({});
    const [redirectHistory, setRedirectHistory] = useState(false);
    const [locationName, setLocationName] = useState('');

    // ----------------------------------------------------
    // API: Fetch WHIRC History Events
    // ----------------------------------------------------
    function fetchWhircHistory(userData, startDate = null, endDate = null) {
        setLoading(true);

        var params = {};
        searchParams.forEach(function (val, key) {
            params[key] = val;
        });

        // Use provided dates or state dates
        const effectiveStartDate = startDate || dateRange[0];
        const effectiveEndDate = endDate || dateRange[1];

        var payload = {
            user_login: userData.user_login,
            user_token: userData.user_token,
            form_input: {
                query: JSON.stringify({
                    attributes: ['count(distinct eventNo) incident_count', 'ifnull(site_name, "Unknown") site_name', 'ifnull(site_id, "Unknown") site_id', "min(DATE_FORMAT(siteTime, '%Y-%m-%d %H:%i:%s')) as start_time", "max(DATE_FORMAT(siteTime, '%Y-%m-%d %H:%i:%s')) as end_time"],
                    object: 'whirc_incidents_view',
                    filters: [
                        { join_by: 'and', attribute: 'siteTime', operator: '>=', value: moment(effectiveStartDate).format('YYYY-MM-DD HH:mm:ss') },
                        { join_by: 'and', attribute: 'siteTime', operator: '<=', value: moment(effectiveEndDate).format('YYYY-MM-DD HH:mm:ss') },
                        userData && userData.site_selected && { join_by: 'and', attribute: 'site_id', operator: '=', value: userData.site_selected.site_id }
                    ],
                    group_by: ['site_id', 'site_name'],
                    pagination: { page: 1, size: 100 },
                    sort_by: [{ attribute: 'siteTime', order: 'desc' }]
                })
            }
        };

        console.log('Fetching WHIRC History with payload:', payload);
        console.log('API URL:', API.DATA.EXPLORER);

        CommonUtils.ajax({
            url: API.DATA.EXPLORER,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(payload)
        }).then(function (res) {
            console.log('WHIRC History Response:', res);

            if (res && res.status && res.status.code === 200 && res.data && res.data.length > 0) {
                const summaryArray = res.data;
                console.log('Summary Data:', summaryArray);
                setSummaryData(summaryArray);
            } else {
                console.log('No incidents found or empty response');
                setSummaryData([]);
            }
            setLoading(false);
        }).catch(function (err) {
            console.error('Error fetching WHIRC history:', err);
            console.error('Error details:', err.responseText || err.message || err);
            setSummaryData([]);
            setLoading(false);
        });
    }

    // Fetch video link for a specific record
    function fetchVideoLink(record) {
        const videoKey = `${record.eventNo}_${record.utcTime}_${record.record.sequence}`;
        setLoadingVideo(prev => ({ ...prev, [videoKey]: true }));

        const payload = {
            user_login: user.user_login,
            user_token: user.user_token,
            user_type: "user",
            form_input: {
                path: "/api/customers/334420/activity/detail",
                payload: {
                    serialNo: parseInt(record.record.serialNo || record.site_id),
                    sequence: record.record.sequence,
                    eventNo: record.eventNo,
                    activityType: 1,
                    dateTime: record.siteTime,
                    utcTime: record.utcTime
                }
            },
            app_name: "SITESUPT"
        };

        console.log('Fetching video with payload:', payload);

        CommonUtils.ajax({
            url: 'https://l3dk2lydd4.execute-api.us-east-1.amazonaws.com/api-env-prod/whirc/by_path',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(payload)
        }).then(function (res) {
            console.log('Video response:', res);
            setLoadingVideo(prev => ({ ...prev, [videoKey]: false }));

            if (res && res.status && res.status.code === 200 && res.data) {
                // Extract URL from rawData XML
                let videoUrl = null;

                if (res.data.rawData) {
                    const urlMatch = res.data.rawData.match(/<URL>(.*?)<\/URL>/);
                    if (urlMatch && urlMatch[1]) {
                        videoUrl = urlMatch[1];
                    }
                }

                if (videoUrl) {
                    // Extract event ID from URL (e.g., https://www.sitesupt.com/event/599285)
                    const eventIdMatch = videoUrl.match(/\/event\/(\d+)/);
                    if (eventIdMatch && eventIdMatch[1]) {
                        const eventId = eventIdMatch[1];
                        console.log('Extracted event ID:', eventId);

                        // Fetch event details and open zone history directly
                        fetchEventAndOpenZoneHistory(eventId);
                    } else {
                        // Fallback: open video URL in new tab if event ID not found
                        window.open(videoUrl, '_blank');
                    }
                } else {
                    console.log('No video URL found in response');
                    alert('Video URL not found in the event data');
                }
            } else {
                console.log('Invalid response from server');
                alert('Video not found or not available');
            }
        }).catch(function (err) {
            console.error('Error fetching video:', err);
            setLoadingVideo(prev => ({ ...prev, [videoKey]: false }));
            alert('Error fetching video. Please try again.');
        });
    }

    // Fetch all records for a specific site
    function fetchRecordsForSite(siteId) {
        setLoadingDetails(prev => ({ ...prev, [siteId]: true }));

        var payload = {
            user_login: user.user_login,
            user_token: user.user_token,
            form_input: {
                query: JSON.stringify({
                    attributes: ['utcTime', "DATE_FORMAT(siteTime, '%Y-%m-%d %H:%i:%s') siteTime", 'eventNo', 'site_id', 'record'],
                    object: 'whirc_incidents_view',
                    filters: [
                        { attribute: 'site_id', value: siteId, operator: '=' },
                        { join_by: 'and', attribute: 'siteTime', operator: '>=', value: moment(dateRange[0]).format('YYYY-MM-DD HH:mm:ss') },
                        { join_by: 'and', attribute: 'siteTime', operator: '<=', value: moment(dateRange[1]).format('YYYY-MM-DD HH:mm:ss') }
                    ],
                    pagination: { page: 1, size: 500 },
                    sort_by: [{ attribute: 'siteTime', order: 'desc' }]
                })
            }
        };

        console.log('Fetching records for site:', siteId);

        CommonUtils.ajax({
            url: API.DATA.EXPLORER,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(payload)
        }).then(function (res) {
            console.log('Records for site response:', res);

            if (res && res.status && res.status.code === 200 && res.data && res.data.length > 0) {
                setExpandedRowDetails(prev => ({ ...prev, [siteId]: res.data }));
            } else {
                console.log('No records found for site:', siteId);
                setExpandedRowDetails(prev => ({ ...prev, [siteId]: [] }));
            }
            setLoadingDetails(prev => ({ ...prev, [siteId]: false }));
        }).catch(function (err) {
            console.error('Error fetching records for site:', err);
            setExpandedRowDetails(prev => ({ ...prev, [siteId]: [] }));
            setLoadingDetails(prev => ({ ...prev, [siteId]: false }));
        });
    }

    // ----------------------------------------------------
    // INIT
    // ----------------------------------------------------
    useEffect(function () {
        document.body.style.background = 'white';

        async function init() {
            try {
                // Get logged-in user session
                let sessionManager = new SessionManager();
                var userData = sessionManager.readCookie('user', false);

                if (!userData) {
                    console.error("No user session found");
                    setLoading(false);
                    return;
                }

                console.log('User session data:', userData);

                setUser(userData);

                // Fetch initial incidents
                fetchWhircHistory(userData);

            } catch (e) {
                console.error("INIT ERROR:", e);
                setLoading(false);
            }
        }

        init();
    }, []);

    function handleGenerateIncidentReport(siteRecord) {
        console.log('Generating report for site:', siteRecord);
        setSelectedSiteForReport(siteRecord);
        setReportModalVisible(true);
    }

    function handleDateRangeChange(dates) {
        if (dates && dates.length === 2) {
            setDateRange(dates);
            if (user) {
                fetchWhircHistory(user, dates[0], dates[1]);
            }
        }
    }

    const fetchEventAndOpenZoneHistory = async (eventId) => {
        const data = {
            user_login: user.user_login,
            user_token: user.user_token,
            source: "D",
            criteria: {
                from: 0,
                size: 1,
                event_id: eventId
            }
        };

        try {
            const res = await CommonUtils.ajax({
                url: API.COMMON_TABLE_OPERATIONS.EVENT_TMP.FETCH,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            });

            if (res && res.status && res.status.code === 200) {
                const records = res.data.records;
                let event_record = records.length > 0 ? records[0] : null;

                if (!event_record) {
                    alert('Event not found or expired');
                    return;
                }

                // Check authorization
                const userSites = Array.isArray(user.user_sites) ? user.user_sites : (user.user_sites ? [user.user_sites] : []);
                const isAuthorized = userSites.some(id => String(id) === String(event_record.site_id));
                if (!isAuthorized) {
                    alert('Not authorized to view this event');
                    return;
                }

                // Find the zone
                let zone_selected = user.zones && user.zones.find(z => z.location_id === event_record.location_id);

                if (!zone_selected) {
                    alert('Zone not found for this event');
                    return;
                }

                // Set ai_event and zone_selected in session
                let ai_event = { sec_timestamp: event_record.sec_timestamp };
                var sessionMgr = new SessionManager();
                let updatedUser = { ...user };
                updatedUser.ai_event = ai_event;
                updatedUser.zone_selected = zone_selected;
                sessionMgr.storeCookie("user", updatedUser);

                // Update local state
                setUser(updatedUser);

                // Open zone history directly
                setRedirectHistory(true);
                setLocationName(zone_selected.location_name || 'Zone History');

                setTimeout(() => {
                    $(".ant-modal-header").css('padding', '0px');
                    $('.ant-modal-wrap').addClass('modal fade show');
                    $('.ant-modal-content').css({ "bottom": "36px" });
                }, 100);
            } else {
                alert('Failed to fetch event details');
            }
        } catch (err) {
            console.error('Error fetching event details:', err);
            alert('Error fetching event details');
        }
    };

    const resizeModal = (e) => {
        setTimeout(() => {
            $('.fa-chevron-left').trigger('click');
        }, 150);
        $(e.target).toggleClass("fa-expand fa-compress");
        $(e.target).closest(".modal-dialog").toggleClass("modal-md modal-fullscreen");
    }

    // ----------------------------------------------------
    // TABLE COLUMNS - Summary Table
    // ----------------------------------------------------
    const summaryColumns = [
        {
            title: 'Site Name',
            dataIndex: 'site_name',
            key: 'site_name',
            width: 200,
            render: (siteName) => siteName || 'N/A',
            sorter: (a, b) => (a.site_name || '').localeCompare(b.site_name || ''),
        },
        {
            title: 'Start Time',
            dataIndex: 'start_time',
            key: 'start_time',
            width: 180,
            render: (startTime) => {
                return startTime ? startTime : 'N/A';
            },
            sorter: (a, b) => moment(a.start_time).unix() - moment(b.start_time).unix(),
        },
        {
            title: 'End Time',
            dataIndex: 'end_time',
            key: 'end_time',
            width: 180,
            render: (endTime) => {
                return endTime ? endTime : 'N/A';
            },
            sorter: (a, b) => moment(a.end_time).unix() - moment(b.end_time).unix(),
        },
        {
            title: 'Event Count',
            dataIndex: 'incident_count',
            key: 'incident_count',
            width: 120,
            render: (incidentCount) => incidentCount || 0,
            sorter: (a, b) => (a.incident_count || 0) - (b.incident_count || 0),
        },
        {
            title: 'Actions',
            key: 'actions',
            width: 150,
            render: (_, record) => (
                <Button
                    type="primary"
                    size="small"
                    onClick={() => handleGenerateIncidentReport(record)}
                    style={{ backgroundColor: '#6b33b4', borderColor: '#6b33b4' }}
                >
                    Generate Report
                </Button>
            ),
        }
    ];

    // ----------------------------------------------------
    // RENDER
    // ----------------------------------------------------
    if (!user) {
        return <div className="container mt-5 pt-5">Loading...</div>;
    }

    return (
        <React.Fragment>
            <BreadCrumb />
            <div className="container mt-5 pt-5">

                <div className="d-flex justify-content-between align-items-center my-3">
                    <div className="text-primary"><b>Incident Manager</b></div>
                    <DatePicker.RangePicker
                        value={dateRange}
                        onChange={handleDateRangeChange}
                        showTime={{
                            format: 'HH:mm',
                            defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                        }}
                        format="YYYY-MM-DD HH:mm"
                        style={{ width: '400px' }}
                    />
                </div>

                {/* Summary Table */}
                <Table
                    columns={summaryColumns}
                    dataSource={summaryData}
                    loading={loading}
                    rowKey={(record) => record.site_id}
                    pagination={{
                        pageSize: 20,
                        showSizeChanger: true,
                        showTotal: (total) => `Total ${total} sites`,
                    }}
                    locale={{
                        emptyText: 'No incidents found'
                    }}
                    scroll={{ x: 800 }}
                    expandable={{
                        expandedRowRender: (record) => {
                            const siteRecords = expandedRowDetails[record.site_id] || [];
                            const isLoadingSite = loadingDetails[record.site_id];

                            if (isLoadingSite) {
                                return <div style={{ padding: '20px', textAlign: 'center' }}>Loading records for site '{record.site_name}'...</div>;
                            }

                            if (siteRecords.length === 0) {
                                return <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>No records found for this site</div>;
                            }

                            return (
                                <div style={{ padding: '20px', backgroundColor: '#fafafa' }}>
                                    <Table
                                        columns={[
                                            {
                                                title: 'Event No',
                                                dataIndex: 'eventNo',
                                                key: 'eventNo',
                                                width: 100,
                                                render: (eventNo, record) => record.record.rowType === 'S' ? <span className="badge badge-warning font-size-13">{record.eventNo}</span> : '',
                                            },
                                            {
                                                title: 'Date/Time',
                                                dataIndex: 'siteTime',
                                                key: 'siteTime',
                                                width: 180,
                                                render: (siteTime) => siteTime ? siteTime : 'N/A',
                                            },
                                            {
                                                title: 'Message',
                                                dataIndex: ['record', 'text'],
                                                key: 'message',
                                                render: (text) => text || 'N/A',
                                            },
                                            {
                                                title: 'Video',
                                                key: 'video',
                                                width: 100,
                                                render: (_, record) => {
                                                    // Only show video link for activity type 1 (Summary records)
                                                    if (record.record.rowType !== 'S') {
                                                        return null;
                                                    }

                                                    const videoKey = `${record.eventNo}_${record.utcTime}_${record.record.sequence}`;
                                                    const isLoading = loadingVideo[videoKey];

                                                    return (
                                                        <span
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                fetchVideoLink(record);
                                                            }}
                                                            style={{
                                                                color: isLoading ? '#999' : '#1890ff',
                                                                cursor: isLoading ? 'not-allowed' : 'pointer',
                                                                textDecoration: 'none'
                                                            }}
                                                        >
                                                            {isLoading ? (
                                                                <>
                                                                    <i className="fa fa-spinner fa-spin"></i> Loading...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fa fa-video"></i> Video
                                                                </>
                                                            )}
                                                        </span>
                                                    );
                                                }
                                            }
                                        ]}
                                        dataSource={siteRecords}
                                        pagination={{ pageSize: 50 }}
                                        rowKey={(rec) => rec.eventNo + '_' + rec.utcTime + '_' + (rec.record && rec.record.sequence)}
                                        size="small"
                                    />
                                </div>
                            );
                        },
                        onExpand: (expanded, record) => {
                            if (expanded && !expandedRowDetails[record.site_id]) {
                                fetchRecordsForSite(record.site_id);
                            }
                        },
                    }}
                />
            </div>

            {/* Security Incident Report Modal */}
            {reportModalVisible && selectedSiteForReport && (
                <Modal
                    title="Security Incident Report"
                    open={true}
                    onCancel={() => {
                        setReportModalVisible(false);
                        setSelectedSiteForReport(null);
                        setSendReportHandler(null);
                    }}
                    footer={[
                        <Button key="close" onClick={() => {
                            setReportModalVisible(false);
                            setSelectedSiteForReport(null);
                            setSendReportHandler(null);
                        }}>
                            Close
                        </Button>,
                        <Button
                            key="send"
                            type="primary"
                            onClick={() => {
                                console.log('Send Report button clicked, handler:', sendReportHandler);
                                if (sendReportHandler) {
                                    console.log('Calling sendReportHandler');
                                    sendReportHandler();
                                } else {
                                    console.log('No handler available');
                                }
                            }}
                            disabled={!sendReportHandler}
                            style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}
                        >
                            Send Report
                        </Button>
                    ]}
                    width="95%"
                    style={{ top: 20 }}
                    bodyStyle={{ height: 'calc(100vh - 200px)', overflow: 'auto', padding: 0 }}
                    zIndex={10000}
                    getContainer={() => document.body}
                >
                    <SecurityIncidentReport
                        siteId={selectedSiteForReport.site_id}
                        dateFrom={dateRange[0].format('YYYY-MM-DD HH:mm:ss')}
                        dateTo={dateRange[1].format('YYYY-MM-DD HH:mm:ss')}
                        isEmbedded={true}
                        onSendReportReady={(handler) => setSendReportHandler(() => handler)}
                    />
                </Modal>
            )}

            {/* Zone History Modal */}
            {redirectHistory && (
                <div style={{ zIndex: 10000, position: 'relative' }} aria-hidden="true">
                    <Modal
                        maskClosable={false}
                        bodyStyle={{ padding: '9px 21px' }}
                        footer={false}
                        className="modal-dialog modal-md"
                        closable={false}
                        open={redirectHistory}
                        title={
                            <div className="modal-header p-2 bg-primary text-white">
                                <span className="modal-title">{locationName}</span>
                                <div>
                                    <button type="button" className="fa fa-expand" onClick={resizeModal}>
                                    </button>
                                    <button type="button" className="far fa-lg fa-times-circle pull-right" data-dismiss="modal" onClick={() => setRedirectHistory(false)}>
                                    </button>
                                </div>
                            </div>
                        }
                        onCancel={() => setRedirectHistory(false)}
                    >
                        <ZoneHistoryCarousel ai_event_date={user.ai_event ? user.ai_event.sec_timestamp : null} hideNotification={true} />
                    </Modal>
                </div>
            )}
        </React.Fragment>
    );
};

export default WhircIncidentManager;
